import { render, staticRenderFns } from "./DocumentViewWithProgress.vue?vue&type=template&id=3acee738&scoped=true&"
import script from "./DocumentViewWithProgress.vue?vue&type=script&lang=ts&"
export * from "./DocumentViewWithProgress.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentViewWithProgress.vue?vue&type=style&index=0&id=3acee738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acee738",
  null
  
)

export default component.exports